module.exports = __webpack_public_path__ + "img/icon-uploadfile.b63b5637.svg";